import {useMemo} from 'react'

import {API_BASE_URL} from 'config'
import Api from 'api'

import useAuthToken from '../persisted/useAuthToken'

import useOnUnauthorized from './useOnUnauthorized'

/**
 * @returns {ApiMethods} Returns Api instance with 'Authorization' header if user is logged in
 */
export default function useApi() {
  const {authToken} = useAuthToken()
  const onUnauthorized = useOnUnauthorized()
  return useMemo(
    () =>
      new Api({
        baseUrl: API_BASE_URL,
        commonHeaders: authToken ? {Authorization: `${authToken}`} : {},
        timeout: 60000,
        onUnauthorized,
      }),
    [authToken, onUnauthorized],
  )
}
